import { ReactNode } from "react";
import SplitScreenLayout from "app/components/SplitScreenLayout";
import * as S from "./AuthPassword.styles";

export type AuthPasswordLayoutVariant = "panel" | "banner" | "none";

export const AUTH_PASSWORD_BANNER_SRC = "/media/flat/mail-inbox.svg";

interface AuthPasswordLayoutProps {
  children: ReactNode;
  variant?: AuthPasswordLayoutVariant;
  rightContent?: ReactNode;
}

function SidePanel({
  variant,
  rightContent,
}: {
  variant: AuthPasswordLayoutVariant;
  rightContent?: ReactNode;
}) {
  if (variant === "none") {
    return null;
  }

  if (variant === "banner") {
    return <S.Banner src={AUTH_PASSWORD_BANNER_SRC} alt="" />;
  }

  return (
    <S.AuthPasswordPanel aria-hidden="true">{rightContent}</S.AuthPasswordPanel>
  );
}

export default function AuthPasswordLayout({
  children,
  variant = "panel",
  rightContent,
}: AuthPasswordLayoutProps) {
  return (
    <SplitScreenLayout
      rightContent={<SidePanel variant={variant} rightContent={rightContent} />}
    >
      {children}
    </SplitScreenLayout>
  );
}

export { default as AuthPasswordSuccessView } from "./AuthPasswordSuccessView";
export { default as AuthLoginFooter } from "./AuthLoginFooter";
export { default as RequiredFieldLabel } from "./RequiredFieldLabel";
export * from "./AuthPassword.styles";
export { AUTH_ILLUSTRATIONS } from "./illustrations";
